import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bf-modal bf-modal--has-sections"
}
const _hoisted_2 = { class: "bf-modal__section" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "bf-heading-display text-body mb-3" }, "Kurskarte kaufen", -1)
const _hoisted_6 = { class: "flex-shrink-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "bf-heading-script"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegionProducts = _resolveComponent("RegionProducts")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.shownLocal,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shownLocal) = $event)),
    close: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      (_ctx.region)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "modal-close-button",
                      "aria-label": "Schließen",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"]))
                    }, _hoisted_8)
                  ])
                ]),
                (_ctx.region?.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, "für Standort " + _toDisplayString(_ctx.region?.name), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_RegionProducts, {
                "region-id": _ctx.region?.id || _ctx.region
              }, null, 8, ["region-id"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "close"]))
}